/* eslint-disable */
import React from 'react';

const cardStyle = {
  background: 'rgba(255,255,255,0.04)',
  border: '1px solid rgba(255,255,255,0.10)',
  borderRadius: 12,
  padding: '20px 22px',
  color: '#F5F5FA',
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
  flex: '1 1 280px',
  minWidth: 260,
  maxWidth: 360,
  boxSizing: 'border-box',
};

const starsStyle = {
  color: '#7B1FA2',
  fontSize: 16,
  letterSpacing: 1.5,
};

const textStyle = {
  fontSize: 14,
  lineHeight: 1.55,
  fontStyle: 'italic',
  opacity: 0.92,
  whiteSpace: 'pre-line',
};

const footerStyle = {
  marginTop: 'auto',
  fontSize: 12,
  opacity: 0.75,
  display: 'flex',
  flexWrap: 'wrap',
  gap: 6,
  alignItems: 'baseline',
};

const nameStyle = {
  fontWeight: 600,
  opacity: 1,
};

const sourceStyle = {
  display: 'inline-block',
  padding: '1px 8px',
  borderRadius: 999,
  fontSize: 10,
  textTransform: 'uppercase',
  letterSpacing: 0.6,
  background: 'rgba(123,31,162,0.20)',
  color: '#E9D7F4',
};

const renderStars = (rating) => {
  const r = Math.max(0, Math.min(5, Number(rating) || 0));
  return '★'.repeat(r) + '☆'.repeat(5 - r);
};

const ReviewCard = ({ review }) => {
  if (!review) return null;
  const { customerName, rating, text, source, date } = review;

  return (
    <div style={cardStyle}>
      <div style={starsStyle} aria-label={`${rating} out of 5 stars`}>
        {renderStars(rating)}
      </div>
      <div style={textStyle}>“{text}”</div>
      <div style={footerStyle}>
        <span style={nameStyle}>{customerName}</span>
        {date && <span>· {date}</span>}
        {source && <span style={sourceStyle}>{source}</span>}
      </div>
    </div>
  );
};

export default ReviewCard;
